var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uE9A3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data-Policy.---Default",
    transform: "translate(-198.000000, -295.000000)",
    fill: "#5f00a0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-details",
    transform: "translate(86.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.574,61.35 L92.574,60.174 L91.426,60.174 L91.426,61.35 L92.574,61.35 Z M92.574,66.026 L92.574,62.526 L91.426,62.526 L91.426,66.026 L92.574,66.026 Z M92,57.276 C93.0640053,57.276 94.0486621,57.5419973 94.954,58.074 C95.8313377,58.5780025 96.5219975,59.2686623 97.026,60.146 C97.5580027,61.0513379 97.824,62.0359947 97.824,63.1 C97.824,64.1640053 97.5580027,65.1486621 97.026,66.054 C96.5219975,66.9313377 95.8313377,67.6219975 94.954,68.126 C94.0486621,68.6580027 93.0640053,68.924 92,68.924 C90.9359947,68.924 89.9513379,68.6580027 89.046,68.126 C88.1686623,67.6126641 87.4780025,66.9173377 86.974,66.04 C86.4419973,65.1346621 86.176,64.1546719 86.176,63.1 C86.176,62.0453281 86.4419973,61.0653379 86.974,60.16 C87.4873359,59.2826623 88.1826623,58.5873359 89.06,58.074 C89.9653379,57.5419973 90.9453281,57.276 92,57.276 Z",
    id: "\\uE9A3"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.70339e1b10346c53c4c2e7b953449369.svg";
export { ForwardRef as ReactComponent };